import type { SubOrderStatusType } from './types';
import { ARTICLE_GROUP_KEYS } from '../constants';

export interface ProductGroup {
  title: string;
  key: string;
  quantity: number;
  description: string;
}

export function getProductGroupsFromSubOrder(
  subOrder: SubOrderStatusType,
  productConstants: Record<string, string>,
): Array<ProductGroup> {
  const productGroups: ProductGroup[] = [];
  subOrder.positions.forEach(position => {
    const { articleGroup, quantity, description } = position;

    // Determine product group based on article group
    if (ARTICLE_GROUP_KEYS.FAB.includes(articleGroup)) {
      const productGroup = {
        title: productConstants.navi_fab,
        key: 'FAB',
        quantity: quantity,
        description: description,
      };
      productGroups.push(productGroup);
    } else if (ARTICLE_GROUP_KEYS.FGE.includes(articleGroup)) {
      const productGroup = {
        title: productConstants.navi_fge,
        key: 'FGE',
        quantity: quantity,
        description: description,
      };
      productGroups.push(productGroup);
    } else if (ARTICLE_GROUP_KEYS.PFB.includes(articleGroup)) {
      const productGroup = {
        title: productConstants.navi_pfb,
        key: 'PFB',
        quantity: quantity,
        description: description,
      };
      productGroups.push(productGroup);
    } else if (ARTICLE_GROUP_KEYS.PFK.includes(articleGroup)) {
      const productGroup = {
        title: productConstants.navi_pfk,
        key: 'PFK',
        quantity: quantity,
        description: description,
      };
      productGroups.push(productGroup);
    } else if (ARTICLE_GROUP_KEYS.FGK.includes(articleGroup)) {
      const productGroup = {
        title: productConstants.navi_fgk,
        key: 'FGK',
        quantity: quantity,
        description: description,
      };
      productGroups.push(productGroup);
    } else if (ARTICLE_GROUP_KEYS.PWB.includes(articleGroup)) {
      const productGroup = {
        title: productConstants.navi_pwb,
        key: 'PWB',
        quantity: quantity,
        description: description,
      };
      productGroups.push(productGroup);
    } else if (ARTICLE_GROUP_KEYS.PHH.includes(articleGroup)) {
      const productGroup = {
        title: productConstants.navi_phh,
        key: 'PHH',
        quantity: quantity,
        description: description,
      };
      productGroups.push(productGroup);
    }
  });

  return productGroups;
}
